<template>
    <properties-find
        :uuid="$route.params.property"
        @success="onPropertiesFindSuccess"
    >
        <div
            slot-scope="{
                data: property,
                error: find_error,
                has_loaded,
                find
            }"
            :class="!has_loaded || find_error ? '' : 'rounded bg-white shadow'"
        >
            <template v-if="!has_loaded || find_error">
                <base-loading
                    :error="find_error"
                    :retry="find"
                    class="py-6"
                />

                <error-modal
                    v-if="find_error"
                    :error="find_error"
                />
            </template>

            <template v-else>
                <properties-update
                    :uuid="property.uuid"
                    @success="onSuccess"
                >
                    <base-form
                        slot-scope="{
                            sid,
                            error: update_error,
                            is_loading: is_saving,
                            update
                        }"
                        @submit="update(form)"
                    >
                        <header class="flex items-center px-4 py-3 border-b sm:px-6 md:py-4">
                            <h1 class="text-lg font-normal">
                                Edit {{ property.name }}
                            </h1>
                        </header>

                        <div class="px-4 py-3 border-b sm:px-6 md:py-6">
                            <validator-alert :sid="sid" />

                            <form-section>
                                <template slot="title">Address</template>
                                <template slot="description">
                                    What's the address of the property?
                                </template>

                                <form-items-address
                                    v-model="form.address"
                                    :sid="sid"
                                    :disabled="is_saving"
                                />
                            </form-section>
                        </div>

                        <div class="px-4 py-3 sm:px-6 md:py-6">
                            <form-section>
                                <template slot="title">Name</template>
                                <template slot="description">
                                    Optionally use your own naming convention. Only you see this.
                                </template>

                                <grid-layout>
                                    <grid-layout-item class="md:w-1/2">
                                        <form-item
                                            :sid="sid"
                                            name="name"
                                        >
                                            <template slot="label">Name</template>

                                            <input-text
                                                v-model="form.name"
                                                :sid="sid"
                                                :placeholder="name"
                                                :disabled="is_saving"
                                                name="address[name]"
                                            />
                                        </form-item>
                                    </grid-layout-item>
                                </grid-layout>
                            </form-section>
                        </div>

                        <div class="px-4 py-3 text-right bg-grey-bg sm:px-6">
                            <base-button
                                :is-loading="is_saving"
                                type="submit"
                                class="w-full btn-blue md:w-auto"
                            >
                                Edit Property
                            </base-button>
                        </div>

                        <error-modal
                            v-if="update_error && $error.is(update_error, { exclude: [422] })"
                            :error="update_error"
                        />

                        <modal-success
                            :is-open="show_updated_modal"
                            @close="show_updated_modal = false"
                        >
                            <template slot="heading">Property Updated!</template>

                            <p>Your property has been updated!</p>

                            <div
                                slot="footer"
                                slot-scope="{ close }"
                                class="flex flex-col md:flex-row-reverse"
                            >
                                <router-link
                                    v-if="property"
                                    :to="{
                                        name: 'dashboard.landlords.properties.show',
                                        params: {
                                            property: property.uuid
                                        }
                                    }"
                                    class="text-center btn btn-green"
                                >
                                    Go to Property
                                </router-link>

                                <button
                                    type="button"
                                    @click.prevent="close"
                                    class="mt-3 text-center btn md:mt-0 md:mr-3"
                                >
                                    Close
                                </button>
                            </div>
                        </modal-success>
                    </base-form>
                </properties-update>
            </template>
        </div>
    </properties-find>
</template>

<script>
    import FormItemsAddress from '../../../../components/form-items-address'
    import PropertiesFind from '../../../../components/properties-find'
    import PropertiesUpdate from '../../../../components/properties-update'

    export default {
        components: {
            FormItemsAddress,
            PropertiesFind,
            PropertiesUpdate
        },
        data () {
            return {
                show_updated_modal: false,
                form: {
                    name: '',
                    address: {
                        street: '',
                        locality: '',
                        village: '',
                        town: '',
                        county: '',
                        postcode: ''
                    }
                }
            }
        },
        computed: {
            name () {
                if (!this.form.name && this.form.address.street) {
                    return this.form.address.street
                }

                return 'e.g. REN7024, Mum\'s, ...'
            }
        },
        methods: {
            reset () {
                this.$validator.reset(this.sid)

                Object.assign(this.$data, this.$options.data.apply(this))
            },
            onSuccess () {
                setTimeout(() => {
                    this.show_updated_modal = true
                }, 0)
            },
            onPropertiesFindSuccess ({ data: property }) {
                this.form.name = property.name
                this.form.address.street = property.address.street
                this.form.address.locality = property.address.locality
                this.form.address.village = property.address.village
                this.form.address.town = property.address.town
                this.form.address.county = property.address.county
                this.form.address.postcode = property.address.postcode
            }
        }
    }
</script>
